@if (tableEntities) {
   <div [ngStyle]="{ overflow: 'auto' }">
       <div class="row">
           <cdk-table-component
               [displayColumns]="displayColumns"
               [entities]="tableEntities"
               [dataSource]="dataSource"
               [footer]="footer"
           ></cdk-table-component>
       </div>
   </div>
}
